import React, { useEffect, useState } from 'react';

const BackgroundIcons = ({ icons = [] }) => {
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    const calculateRandomPositions = () => {
      const newPositions = [];
      const usedAreas = [];

      // Define safe zones where content typically doesn't exist
      const safeZones = [
        // Top corners and edges
        { x: 5, y: 5, width: 15, height: 15 },
        { x: 80, y: 5, width: 15, height: 15 },
        // Side margins
        { x: 2, y: 25, width: 12, height: 20 },
        { x: 86, y: 25, width: 12, height: 20 },
        { x: 2, y: 55, width: 12, height: 20 },
        { x: 86, y: 55, width: 12, height: 20 },
        // Bottom areas
        { x: 5, y: 80, width: 15, height: 15 },
        { x: 80, y: 80, width: 15, height: 15 },
        { x: 15, y: 75, width: 10, height: 10 },
        { x: 75, y: 75, width: 10, height: 10 }
      ];

      const isPositionTooClose = (pos, used) => 
        Math.abs(used.left - pos.left) < 8 && Math.abs(used.top - pos.top) < 8;

      icons.forEach((icon, index) => {
        let position;
        let attempts = 0;
        const maxAttempts = 15;

        do {
          // Randomly pick a safe zone or edge area
          if (Math.random() > 0.3 && attempts < safeZones.length) {
            const zone = safeZones[Math.floor(Math.random() * safeZones.length)];
            position = {
              left: zone.x + Math.random() * zone.width,
              top: zone.y + Math.random() * zone.height
            };
          } else {
            // Random edge positioning
            const edge = Math.floor(Math.random() * 4);
            switch (edge) {
              case 0: // Top
                position = { left: Math.random() * 90 + 5, top: Math.random() * 20 + 5 };
                break;
              case 1: // Right
                position = { left: Math.random() * 15 + 80, top: Math.random() * 80 + 10 };
                break;
              case 2: // Bottom
                position = { left: Math.random() * 90 + 5, top: Math.random() * 15 + 80 };
                break;
              default: // Left
                position = { left: Math.random() * 15 + 2, top: Math.random() * 80 + 10 };
            }
          }
          attempts++;
        } while (
          attempts < maxAttempts &&
          usedAreas.some(used => isPositionTooClose(position, used))
        );

        usedAreas.push(position);
        newPositions.push({
          ...position,
          rotation: Math.random() * 30 - 15,
          zIndex: Math.floor(Math.random() * 3) + 1
        });
      });

      setPositions(newPositions);
    };

    if (icons.length > 0) {
      calculateRandomPositions();
    }
  }, [icons]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {icons.map((icon, index) => {
        const position = positions[index];
        if (!position) return null;

        return (
          <div
            key={`random-icon-${index}`}
            className={`absolute text-${icon.size} opacity-${icon.opacity} select-none`}
            style={{
              left: `${position.left}%`,
              top: `${position.top}%`,
              transform: `rotate(${position.rotation}deg)`,
              zIndex: position.zIndex
            }}
          >
            {icon.emoji}
          </div>
        );
      })}
    </div>
  );
};

export default BackgroundIcons;
